
    // this file was auto generated by python script
    import File from './File';
    export default File;
    